import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

// Renders an uptime trend line from the dashboard's timeseries action, styled
// like the Locations page charts (chart title, legend box, point markers).
// Kept separate from charts_controller because those charts pin their x-axis
// to the last 24 hours while this one spans the filtered period.
export default class UptimeChartController extends Controller {
  static targets = ['canvas', 'loader']
  static values = { url: String, color: String, label: String, title: String }

  async connect () {
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: 'application/json' } })
      const data = await response.json()
      this.loaderTarget.classList.add('hidden')
      this.canvasTarget.classList.remove('hidden')
      const color = this.colorValue || '#36A2EB'
      this.chart = new Chart(this.canvasTarget, {
        type: 'line',
        data: {
          labels: data.labels,
          datasets: Object.entries(data.values).map(([key, values]) => ({
            label: this.labelValue || key,
            data: values,
            borderColor: color,
            backgroundColor: color,
            spanGaps: true,
            pointRadius: 2,
            tension: 0.1
          }))
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { intersect: false, mode: 'index' },
          scales: {
            x: { title: { display: true, text: 'Date' }, ticks: { maxTicksLimit: 12 } },
            y: { min: 0, max: 100, title: { display: true, text: 'Uptime (%)' } }
          },
          plugins: {
            legend: { display: true, position: 'top' },
            title: { display: !!this.titleValue, text: this.titleValue }
          }
        }
      })
    } catch {
      this.loaderTarget.textContent = 'Error while building the chart'
    }
  }

  disconnect () {
    if (this.chart) this.chart.destroy()
  }
}
